module.exports = __webpack_public_path__ + "img/5.f12c6bf9.jpg";